import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { leadScoringActivity } from "../../../common/constants";
import { createLeadScore } from "../../../redux/actions/pricing";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
const Accordian = ({ title, content, userToggle ,index,length}) => {
  const [isActive, setIsActive] = useState(false);
  const user_id = useSelector(store => store?.profileDetails?.id)

  return (
    !userToggle ? 
    <div className={isActive === false ?`bg-[#E2F8FF]  text-pricing_blue flex flex-col justify-center  border-gray-200 border-2 px-2 ${index === 0 ? 'rounded-t-lg' : index === length-1 ? 'rounded-b-lg' : ''}` : ` bg-[#E2F8FF] text-pricing_blue flex flex-col justify-center  border-gray-200 border-2 px-2 ${index === 0 ? 'rounded-t-lg' : index === length-1 ? 'rounded-b-lg' : ''}`}>
      <div
        className="flex flex-row justify-between items-center w-full"
        onClick={(event) => {
          setIsActive(!isActive)
          createLeadScore(user_id, leadScoringActivity.CLICKED_GENERAL.type)
        }}
      >
        <div className="text-[14px] md:text-[20px] w-[85%] font-medium cursor-pointer py-2" dangerouslySetInnerHTML={{ __html: title}}/>
        <FontAwesomeIcon icon={isActive ? faAngleDown :faAngleRight} className="tracking-widest text-[18px] md:text-2xl cursor-pointer" />
      </div>
      {isActive && <div className="mt-2" dangerouslySetInnerHTML={{ __html: content }}/>}
    </div>
    :
    <div className={isActive === false ? "bg-white  flex flex-col justify-center rounded-sm border-gray-200 border-2 px-2" : "bg-white  flex flex-col justify-center rounded-sm border-gray-200 border-2 px-2"}>
      <div
        className="flex flex-row justify-between"
        onClick={(event) => {
          setIsActive(!isActive)
          createLeadScore(user_id, leadScoringActivity.CLICKED_GENERAL.type)
        }}
      >
        <div className="text-lg font-medium cursor-pointer py-2" dangerouslySetInnerHTML={{ __html: title}}/>
        <div className="tracking-widest text-2xl cursor-pointer">{isActive ? "-" : "+"}</div>
      </div>
      {isActive && <div className="mt-2" dangerouslySetInnerHTML={{ __html: content }}/>}
    </div>
  );
};

export default Accordian;
